import React, { useState, useEffect } from 'react'
import { isIosDevice, isStandalonePwa } from 'utils/pwaInstall'
import s from './styles.module.scss'

const FloatingPlayStoreButton = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isStandalone, setIsStandalone] = useState(false)
  const [hideOnIos, setHideOnIos] = useState(false)

  useEffect(() => {
    const checkStandaloneMode = () => {
      setIsStandalone(isStandalonePwa())
      setHideOnIos(isIosDevice())
    }

    checkStandaloneMode()
  }, [])

  const handlePlayStoreClick = () => {
    // BCN India app Play Store URL
    const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.bcnindia'
    window.open(playStoreUrl, '_blank')
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  // Play Store is Android-only; iOS users see InstallAppPrompt instead
  if (isStandalone || hideOnIos) {
    return null
  }

  return (
    <div className={s.floatingButtonContainer}>
      {/* Main floating button */}
      <div 
        className={`${s.floatingButton} ${isExpanded ? s.expanded : ''}`}
        onClick={isExpanded ? handlePlayStoreClick : toggleExpanded}
      >
        <div className={s.buttonIcon}>
          {isExpanded ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3 12L21 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M12 3L12 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          ) : (
            <div className={s.playStoreIcon}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z" fill="currentColor"/>
                <path d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z" fill="currentColor"/>
                <path d="M20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.5 12.92 20.16 13.19L16.81 15.12L14.54 12.85L16.81 10.58L20.16 10.81Z" fill="currentColor"/>
                <path d="M6.05 2.66L16.81 8.88L14.54 11.15L6.05 2.66Z" fill="currentColor"/>
              </svg>
              <div className={s.downloadText}>Download</div>
            </div>
          )}
        </div>
        
        {/* Expanded content */}
        {isExpanded && (
          <div className={s.expandedContent}>
            <div className={s.playStoreIconLarge}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z" fill="currentColor"/>
                <path d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z" fill="currentColor"/>
                <path d="M20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.5 12.92 20.16 13.19L16.81 15.12L14.54 12.85L16.81 10.58L20.16 10.81Z" fill="currentColor"/>
                <path d="M6.05 2.66L16.81 8.88L14.54 11.15L6.05 2.66Z" fill="currentColor"/>
              </svg>
            </div>
            <div className={s.appInfo}>
              <h4>Download App</h4>
              <p>BCN India - Brahmin Community</p>
            </div>
            <div className={s.downloadIcon}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        )}
      </div>

      {/* Pulse animation ring */}
      <div className={s.pulseRing}></div>
    </div>
  )
}

export default FloatingPlayStoreButton
